export default __webpack_public_path__ + "static/media/img--living-dining-2.347341c0.jpg";